export { Tabs, TabPanel } from './Tabs';
